import template from './navbar.html';
import controller from './navbar.controller';

let navbarComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default navbarComponent;



// WEBPACK FOOTER //
// ./app/common/navbar/navbar.component.js